<mat-card class="selection-section card-margin">
  <div class="panel_sub_header">
      <span class="panel__header__title">   {{"Select Filter" | translate | async}}</span>
  </div>
  <div class="customer-notes-filter">
      <mat-form-field class="search-input">
          <mat-select  [(ngModel)]="selectedCustomer" name="customer" placeholder="{{'Select Customer' | translate | async}}">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let customer of selectionLists.customerList" [value]="customer">
              {{ customer.Title }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div> <mat-checkbox class="checkbox-margin" [(ngModel)]="searchItem.StartDateCheck">{{'Include Start Date'| translate | async}}</mat-checkbox> </div>
        <mat-form-field  class="search-input" *ngIf="searchItem.StartDateCheck">
            <input   matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'| translate | async}}" [ngModel]="searchItem.StartDate" (ngModelChange) = "StartDateChanged($event); "
              [formControl]="StartDateControl">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <div> <mat-checkbox  class="checkbox-margin" [(ngModel)]="searchItem.EndDateCheck">{{'Include End Date'| translate | async}}</mat-checkbox> </div>
        <mat-form-field  class="search-input" *ngIf="searchItem.EndDateCheck">
            <input  matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'| translate | async}}" [ngModel]="searchItem.EndDate" (ngModelChange) = "EndDateChanged($event); "
              [formControl]="EndDateControl">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <span class="search-button">
          <a class="button button--primary" (click)="searchCustomerNote()"><i class="material-icons button__icon">search</i><span
                    class="button__text">{{'Search' | translate | async}}</span></a>
        </span>
  </div>
</mat-card>


<mat-card class = "customer-notes-list-table card-margin">
<div>
    <div>
        <div class="panel_sub_header">
            <span class="panel__header__title"> {{"Customer Notes" | translate | async}}</span>
            <span class="add-customer-button">
                <a class="button button--primary" (click)="addNewCustomerNotes()"><i class="material-icons button__icon">add</i><span
                  class="button__text">{{'Add New' | translate | async}}</span></a>
            </span>
        </div>
        <div>
          <panel class="no-padding table-panel">
            <div class="mat-elevation-z8">
              <mat-table #table mat-table [dataSource]="dataSource"  matSort>

                <ng-container matColumnDef="AddressToCustomerName">
                  <mat-header-cell *matHeaderCellDef  mat-sort-header> {{'Address To Customer Name' | translate | async }} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.AddressToCustomerName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CreatedDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Created Date' | translate | async }}  </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.CreatedDate | date:'yyyy-MM-dd'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Note">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>  {{'Notes' | translate | async }} </mat-header-cell>
                  <mat-cell  *matCellDef="let element"> {{element.Note}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CreatedUserName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Created By' | translate | async }} </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.CreatedUserName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Edit">
                    <mat-header-cell *matHeaderCellDef> {{'Edit' | translate | async }} </mat-header-cell>
                    <mat-cell *matCellDef="let element"> <button mat-stroked-button color="primary" (click)="editCustomerNotes(element)" > {{"Edit" | translate | async}}</button> </mat-cell>
                  </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>

              <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
          </panel>
        </div>

      </div>


  </div>

</mat-card>
